import {
  descriptionUI,
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import RepresentativeDescription from '../../../components/FormDescriptions/ApplicationSignatureDescription';
import content from '../../../locales/en/content.json';

const TITLE_TEXT = content['sign-as-rep-title--review'];
const INPUT_LABEL = content['sign-as-rep-input-label'];

const SCHEMA_LABELS = {
  no: content['sign-as-rep-no-text'],
  yes: content['sign-as-rep-yes-text'],
};
const SCHEMA_ENUM = Object.keys(SCHEMA_LABELS);

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...descriptionUI(RepresentativeDescription),
    signAsRepresentativeYesNo: radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
    }),
  },
  schema: {
    type: 'object',
    properties: {
      signAsRepresentativeYesNo: radioSchema(SCHEMA_ENUM),
    },
  },
};
